<template>
    <div>
        <vs-row>
            <vs-col vs-lg="6" vs-sm="3" vs-xs="12">
                <label class="vs-input--label mb-0">Nombre <span style="color: red;">*</span></label>
                <vs-input class="inputx w-100" placeholder="Ingrese el nombre" v-model="name" name="name"
                    v-validate="'required'" type="Text" maxlength="30" data-vv-name="name" />
            </vs-col>
            <vs-col vs-lg="6" vs-sm="3" vs-xs="12">
                <label class="vs-input--label mb-0">Tipo de liquidación <span style="color: red;">*</span></label>
                <vs-select class="w-100" v-model="liquidationType" data-vv-name="liquidationType" name="liquidationType"
                    placeholder="Seleccione el tipo">
                    <vs-select-item :key="index" :value="item.code" :text="item.title"
                        v-for="(item, index) in liquidationTypes" v-validate="'required'" />
                </vs-select>
            </vs-col>
        </vs-row>
        <br>
        <br>
        <vs-row>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <h5 style="margin-top: 5px;">Conceptos de la liquidación</h5>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                <vs-button icon="add" color="primary" class="flex-shrink-0 ml-auto" style="margin-top: 0px;"
                    @click="addConcept()" :disabled="disabledAdd">Agregar concepto</vs-button>
            </vs-col>
        </vs-row>
        <br>
        <form autocomplete="off">
            <vs-row vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-col vs-lg="2" vs-sm="2" vs-xs="12">
                    <label class="vs-input--label mb-0">Concepto <span style="color: red;">*</span></label>
                    <vs-select class="w-100" v-model="concept" data-vv-name="concept" name="concept"
                        placeholder="Busque y seleccione el concepto" autocomplete>
                        <vs-select-item :key="index" :value="item.code" :text="item.title" v-for="(item, index) in concepts"
                            v-validate="'required'" />
                    </vs-select>
                </vs-col>
                <vs-col vs-lg="1" vs-sm="1" vs-xs="12" style="
            width: 50px !important; padding: 0px; margin-top: 20px;">
                    <vs-button color="primary" type="filled" icon="add" @click="openCreateConcept('Crear')"></vs-button>
                </vs-col>
                <vs-col vs-lg="1" vs-sm="1" vs-xs="12" style="
            width: 50px !important; padding: 0px; margin-top: 20px;">
                    <vs-button color="primary" type="filled" icon="edit" @click="openCreateConcept('Editar')"
                        :disabled="disabledEditConcept"></vs-button>
                </vs-col>
                <vs-col vs-lg="8" vs-sm="8" vs-xs="12">
                    <vs-col vs-lg="3" vs-sm="3" vs-xs="12" style="margin-right: 10px;">
                        <label class="vs-input--label mb-0">Tipo de ejecución <span style="color: red;">*</span></label>
                        <vs-select class="w-100" v-model="runtimeType" placeholder="Seleccione el tipo">
                            <vs-select-item :key="index" :value="item.code" :text="item.title"
                                v-for="(item, index) in runtimeTypes" />
                        </vs-select>
                    </vs-col>
                    <vs-col vs-lg="2" vs-sm="2" vs-xs="12" v-if="showValue" style="margin-right: 10px;">
                        <label class="vs-input--label mb-0">Valor <span style="color: red;">*</span></label>
                        <vs-input class="inputx w-100" placeholder="Ingrese el valor" v-model="value" name="value"
                            type="Number" @input="value = value.slice(0, 7)" />
                    </vs-col>
                    <vs-col vs-lg="2" vs-sm="2" vs-xs="12" v-if="showFunction" style="margin-right: 10px;">
                        <label class="vs-input--label mb-0">Función <span style="color: red;">*</span></label>
                        <vs-select class="w-100" v-model="functionType" placeholder="Seleccione la función" autocomplete>
                            <vs-select-item :key="index" :value="item.code" :text="item.title"
                                v-for="(item, index) in functionTypes" />
                        </vs-select>
                    </vs-col>
                    <vs-col vs-lg="2" vs-sm="2" vs-xs="12" v-if="showRate">
                        <label class="vs-input--label mb-0">Tarifa <span style="color: red;">*</span></label>
                        <vs-select class="w-100" v-model="rate" placeholder="Seleccione la tarifa" autocomplete>
                            <vs-select-item :key="index" :value="item.code" :text="item.id + ' - ' + item.title"
                                v-for="(item, index) in rates" />
                        </vs-select>
                    </vs-col>
                </vs-col>
            </vs-row>
        </form>
        <br>
        <vs-row>
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-table stripe pagination max-items="5" :data="listAddedConcepts" class="text-nowrap"
                    noDataText="No se encontraron conceptos relacionados">
                    <template slot="thead">
                        <vs-th sort-key="conceptConcept">Concepto</vs-th>
                        <vs-th sort-key="conceptRuntimeType">Tipo de ejecución</vs-th>
                        <vs-th sort-key="conceptValue">Valor</vs-th>
                        <vs-th sort-key="conceptFunction">Función</vs-th>
                        <vs-th sort-key="conceptRate">Tarifa</vs-th>
                        <vs-th sort-key="conceptRelated">Conceptos relacionados</vs-th>
                        <vs-th sort-key="conceptActions">Acciones</vs-th>
                    </template>
                    <template slot-scope="{data}" v-if="data">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].concept.title" style="width: 100px;">
                                <div>
                                    <span class=" badge-pill ">{{ data[indextr].concept.title }}</span>
                                </div>
                            </vs-td>
                            <vs-td :data="data[indextr].runtimeType.title" style="width: 200px;">
                                <div>
                                    <span class=" badge-pill ">{{ data[indextr].runtimeType.title }}</span>
                                </div>
                            </vs-td>
                            <vs-td :data="data[indextr].value" style="width: 80px;">
                                <div>
                                    <span class=" badge-pill ">{{ data[indextr].value }}</span>
                                </div>
                            </vs-td>
                            <vs-td :data="data[indextr].functionType.title" style="width: 100px;">
                                <div>
                                    <span class=" badge-pill ">{{ data[indextr].functionType.title }}</span>
                                </div>
                            </vs-td>
                            <vs-td :data="data[indextr].rate.id + ' - ' + data[indextr].rate.title" style="width: 80px;">
                                <div>
                                    <span class=" badge-pill ">{{ data[indextr].rate.id + ' - ' +
                                        data[indextr].rate.title
                                    }}</span>
                                </div>
                            </vs-td>
                            <vs-td :data="data[indextr].relates">
                                <div>
                                    <span class=" badge-pill ">{{ data[indextr].relates }}</span>
                                </div>
                            </vs-td>
                            <vs-td style="width: 150px;">
                                <div class="d-flex align-items-center">
                                    <vs-button color="danger" type="filled" icon="delete"
                                        @click="removeConcept(data[indextr])"
                                        style="margin-right: 5px;"></vs-button>
                                    <vs-button color="primary" type="filled" icon="edit"
                                        :disabled="data[indextr].showEditRelated"
                                        @click="openEditRelated(data[indextr])"></vs-button>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-col>
        </vs-row>
        <br>
        <vs-row class="d-flex justify-content-end">
            <vs-col vs-lg="2" vs-sm="4" vs-xs="12">
                <div class="d-flex">
                    <vs-button color="#4A5D71" class="flex-shrink-0 ml-auto" style="margin-top: 0px;"
                        :disabled="disabledCopy" @click="liquidationCopy()">Copiar liquidación</vs-button>
                </div>
            </vs-col>
            <vs-col vs-lg="1" vs-sm="4" vs-xs="12">
                <div class="d-flex">
                    <vs-button color="rgb(255,186,0)" class="flex-shrink-0 ml-auto" style="margin-top: 0px;"
                        @click="cancel()">Cancelar</vs-button>
                </div>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="4" vs-xs="12" style="width: 160px !important">
                <div class="d-flex">
                    <vs-button color="primary" class="flex-shrink-0 ml-auto" style="margin-top: 0px;"
                        :disabled="disabledSave" @click="saveLiquidation()">Guardar liquidación</vs-button>
                </div>
            </vs-col>
        </vs-row>
        <DialogConcepts :company=company :openDialogConcept=openDialogConcept :concepts=concepts
            v-bind:conceptEdit=conceptEdit v-bind:titleDialog=titleDialog v-on:close="closeCreateConcept"
            :conceptNew=showConceptNew v-on:closeEdit="closeEditConcept"></DialogConcepts>

        <DialogLiquidationCopy :company=company :openDialogLiquidationCopy=openDialogLiquidationCopy
            :liquidation=liquidation v-on:close="closeLiquidationCopy"></DialogLiquidationCopy>

        <DialogEditRelated :company=company :openDialogEditRelated=openDialogEditRelated :relatedEdit=relatedEdit
            v-on:closeEditRelated="closeEditRelated" v-on:receiveNewValue="receiveNewValue"></DialogEditRelated>

    </div>
</template>
  
<script>
import { ROUTES } from "@/global/api_routes";
import unityEndpoint from "@/endpoints/core/UnityEndpoint";
import { configToast, TOAST_TYPES } from "@/global/toast";
import kind from "@/global/lasting/EKind";
import ERuntimeType from "@/global/lasting/ERuntimeType";
import DialogConcepts from "./dialog-concepts";
import DialogLiquidationCopy from "./dialog-liquidation-copy";
import DialogEditRelated from "./dialog-related";
import { confirmation } from "@/global/utils";

export default {
    name: "FormLiquidation",
    components: {
        DialogConcepts,
        DialogEditRelated,
        DialogLiquidationCopy
    },
    props: ['company', 'liquidation', 'newLiquidation'],
    data: () => ({
        liquidationTypes: [],
        liquidationType: null,
        name: null,
        concept: null,
        concepts: [],
        runtimeType: null,
        runtimeTypes: [],
        value: null,
        functionType: null,
        functionTypes: [],
        rate: null,
        rates: [],
        listAddedConcepts: [],
        openDialogConcept: false,
        actualCode: null,
        showValue: false,
        showFunction: false,
        showRate: false,
        disabledSave: true,
        disabledAdd: true,
        disabledCopy: true,
        conceptRelates: null,
        listRelates: null,
        disabledEditConcept: true,
        conceptEdit: null,
        titleDialog: null,
        openDialogLiquidationCopy: false,
        openDialogEditRelated: false,
        relatedEdit: null,
        showConceptNew: false,
        conceptDeleted: []
    }),
    watch: {
        liquidation() {
            this.getLiquidation();
            this.getRuntimeTypes();
            this.newLiquidation = false;
        },
        newLiquidation() {
            if (this.newLiquidation) {
                this.cleanForm();
                this.listAddedConcepts = [];
                this.actualCode = null;
            }
        },
        concept() {
            if (this.concept) {
                this.disabledAdd = false;
                this.disabledEditConcept = false;
                this.getConceptsRelates(this.concept);
            }
        },
        runtimeType() {
            switch (this.runtimeType) {
                case ERuntimeType.FUNCTION:
                    this.showFunction = true;
                    this.showValue = true;
                    this.showRate = false;
                    break;
                case ERuntimeType.TARIFF:
                    this.showRate = true;
                    this.showFunction = false;
                    this.showValue = false;
                    break;
                default:
                    this.showValue = true;
                    this.showFunction = false;
                    this.showRate = false;
            }
        },
        name() {
            this.validateFields();
        },
        liquidationType() {
            this.validateFields();
        },
        company() {
            this.cleanForm();
            this.listAddedConcepts = [];
            this.cancel();
        }
    },
    mounted() {
        this.getLiquidationTypes();
        this.getConcepts();
        this.getRuntimeTypes();
        this.getTariffs();
        this.getFunctions();
        this.getLiquidation();
        if (this.newLiquidation) {
            this.cleanForm();
            this.listAddedConcepts = [];
            this.actualCode = null;
        }
    },
    methods: {
        toast(message, type = TOAST_TYPES.INFO) {
            const instance = configToast(this, "#rates_container");
            return instance.open(message, type);
        },
        getLiquidationTypes() {
            unityEndpoint.getUnityListByKind(kind.LIQUIDATION_TYPES)
                .then(info => this.liquidationTypes = info);
        },
        getRuntimeTypes() {
            unityEndpoint.getUnityListByKind(kind.RUNTIME_TYPES)
                .then(info => this.runtimeTypes = info);
        },
        getConcepts() {
            this.$http
                .get(ROUTES.DASHBOARD.CONCEPTS.LIST_BY_COMPANY, {
                    params: {
                        companyId: this.company,
                    }
                })
                .then(({ data }) => {
                    if (data.code > 0) {
                        this.concepts = data.info;
                    }
                });
        },
        getTariffs() {
            this.$http
                .get(ROUTES.DASHBOARD.RATES.GET_RATES_COMPLETE, {
                    params: {
                        companyId: this.company,
                    },
                })
                .then(({ data }) => {
                    if (data.code > 0) {
                        this.rates = data.info;
                        return;
                    }
                });
        },
        openCreateConcept(type) {
            this.openDialogConcept = true;
            this.conceptEdit = type === 'Crear' ? null : this.concepts.find(e => e.code === this.concept);
            this.titleDialog = type;
            this.showConceptNew = type === 'Crear' ? true : false;
        },
        closeCreateConcept: function (conceptCreated) {
            this.openDialogConcept = false;
            this.getConcepts();
            this.concept = conceptCreated.code;
        },
        closeEditConcept: function () {
            this.openDialogConcept = false;
            this.concept = null;
            this.disabledEditConcept = true;
        },
        addConcept() {
            if (this.validateFieldsConcepts()) {
                if (this.validateConceptRelated()) {
                    this.listAddedConcepts.push({
                        concept: this.concept != null ? { code: this.concepts.find(e => e.code === this.concept).code, title: this.concepts.find(e => e.code === this.concept).title } : { code: "", title: "" },
                        runtimeType: this.runtimeType != null ? { code: this.runtimeTypes.find(e => e.code === this.runtimeType).initials, title: this.runtimeTypes.find(e => e.code === this.runtimeType).title } : { code: "", title: "" },
                        value: this.value,
                        functionType: this.functionType != null ? { code: this.functionTypes.find(e => e.code === this.functionType).code, title: this.functionTypes.find(e => e.code === this.functionType).title } : { code: "", title: "" },
                        rate: this.rate != null ? { id: this.rates.find(e => e.code === this.rate).id, code: this.rates.find(e => e.code === this.rate).code, title: this.rates.find(e => e.code === this.rate).title } : { code: "", id: "", title: "" },
                        relates: this.listRelates != null ? this.listRelates : "",
                    });
                    this.cleanFormConcept();
                }
                else {
                    this.$toastError("El concepto que intenta relacionar a la liquidación, ya se encuentra asociado");
                    this.cleanFormConcept();
                }
            }
        },
        saveLiquidation() {
            this.$validator.validateAll().then((result) => {
                if (!result || !this.validateConcepts()) {
                    return;
                }
                this.$vs.loading();
                this.deleteConceptRelated();
                this.$http
                    .post(ROUTES.DASHBOARD.LIQUIDATIONS.SAVE, this.getObj())
                    .then(({ data }) => {
                        if (data.code > 0) {
                            this.$toastOk("Se ha guardado correctamente el registro");
                            this.$emit('updateLiquidations');
                            this.cancel();
                            this.cleanForm();
                            this.listAddedConcepts = [];
                            return;
                        }
                        else { this.$toastError(data.message); }
                    })
                    .finally(() => {
                        this.$vs.loading.close();
                    });
            });
        },
        getObj() {
            return {
                code: this.actualCode,
                title: this.name,
                numeral: this.liquidation ? this.liquidation.numeral : 1,
                company: { code: this.company },
                liquidationType: { code: this.liquidationType },
                relatedList: this.listAddedConcepts
                    .filter(item => item.concept)
                    .map((item, index) => {
                        const obj = {
                            code: item.code,
                            concept: item.concept,
                            runtimeType: item.runtimeType.code,
                            value: item.value,
                            function: item.functionType,
                            tariff: item.rate
                        };
                        obj.orderAt = index + 1;
                        return obj;
                    }),
            }
        },
        cancel() {
            this.$emit('cancel');
        },
        getFunctions() {
            this.$http
                .get(ROUTES.DASHBOARD.LIQUIDATIONS.GET_FUNCTIONS)
                .then(({ data }) => {
                    if (data.code > 0) {
                        this.functionTypes = data.info;
                        return;
                    }
                });
        },
        validateConcepts() {
            if (!this.listAddedConcepts || this.listAddedConcepts.length === 0) {
                this.$toastInfo("Debes asociar al menos un concepto");
                return false;
            }
            return true;
        },
        getLiquidation() {
            this.listAddedConcepts = [];
            if (this.liquidation) {
                this.actualCode = this.liquidation.code;
                this.name = this.liquidation.title;
                this.liquidationType = this.liquidation.liquidationType.code;
                if (this.liquidation.relatedList.length > 0) {
                    this.liquidation.relatedList.forEach(async conceptRelated => {
                        this.listAddedConcepts.push({
                            concept: conceptRelated.concept != null ? { code: conceptRelated.concept.code, title: conceptRelated.concept.title } : { code: "", title: "" },
                            runtimeType: conceptRelated.runtimeType != null ? { code: conceptRelated.runtimeType, title: conceptRelated.runtimeType } : { code: "", title: "" },
                            value: conceptRelated.value,
                            functionType: conceptRelated.function != null ? { code: conceptRelated.function.code, title: conceptRelated.function.title } : { code: "", title: "" },
                            rate: conceptRelated.tariff != null ? { code: conceptRelated.tariff.code, title: conceptRelated.tariff.title, id: conceptRelated.tariff.id } : { code: "", title: "", id: "" },
                            relates: await this.getConceptsRelates(conceptRelated.concept.code),
                            code: conceptRelated.code,
                            showEditRelated: conceptRelated.runtimeType === "TARIFF" ? true : false
                        });
                    });
                }
                this.disabledCopy = false;
            }
        },
        cleanForm() {
            this.liquidationType = null;
            this.name = null;
            this.conceptDeleted = [];
        },
        validateFields() {
            if (this.name && this.liquidationType) {
                this.disabledSave = false;
            }
            else {
                this.disabledSave = true;
            }
        },
        getConceptsRelates(concept) {
            return new Promise((resolve) => {
                let relates = "";
                this.$vs.loading();
                this.$http
                    .get(ROUTES.DASHBOARD.CONCEPTS.LIST_CONCEPT_RELATEDS,
                        {
                            params: { conceptCode: concept }
                        })
                    .then(({ data }) => {
                        if (data.code > 0) {
                            data.info.forEach(related => {
                                relates = related.title + " - " + relates;
                                this.listRelates = relates;
                                resolve(relates);
                            });
                        }
                        else {
                            resolve("");
                        }
                    }).finally(() => {
                        this.$vs.loading.close();
                    });
            });
        },
        removeConcept(concept) {
            confirmation(this, "¿Estás seguro que deseas eliminar el concepto relacionado a la liquidación?").then((result) => {
                if (!result) {
                    return;
                }
                this.deleteConceptRelatedTemp(concept);
            });
        },
        deleteConceptRelatedTemp(concept) {
            this.conceptDeleted.push(concept);
            let indexConcept = this.listAddedConcepts.findIndex(e => e.concept.code == concept.concept.code);
            this.listAddedConcepts.splice(indexConcept, 1);
        },
        deleteConceptRelated() {
            this.conceptDeleted.forEach(concept => {
                if (concept.code) {
                    this.$http
                        .delete(ROUTES.DASHBOARD.LIQUIDATIONS.DELETE_RELATED, {
                            params: {
                                liquidationConceptCode: concept.code,
                            },
                        });
                }
            });
        },
        liquidationCopy() {
            this.openDialogLiquidationCopy = true;
        },
        closeLiquidationCopy: function () {
            this.openDialogLiquidationCopy = false;
        },
        validateFieldsConcepts() {
            let associateConcepts = true;
            switch (this.runtimeType) {
                case ERuntimeType.FUNCTION:
                    if (!this.value || !this.functionType) {
                        associateConcepts = false;
                        this.toast("Debe especificar el valor y la función que tendrá el concepto.", TOAST_TYPES.ERROR);
                    }
                    break;
                case ERuntimeType.TARIFF:
                    if (!this.rate) {
                        associateConcepts = false;
                        this.toast("Debe especificar la tarifa que tendrá el concepto.", TOAST_TYPES.ERROR);
                    }
                    break;
                default:
                    if (!this.value) {
                        associateConcepts = false;
                        this.toast("Debe especificar el valor que tendrá el concepto.", TOAST_TYPES.ERROR);
                    }
            }
            return associateConcepts;
        },
        openEditRelated: function (related) {
            this.relatedEdit = related;
            this.openDialogEditRelated = true;
        },
        closeEditRelated: function () {
            this.openDialogEditRelated = false;
        },
        receiveNewValue() {
            this.$vs.loading()
            this.$http
                .get(ROUTES.DASHBOARD.LIQUIDATIONS.FIND_LIQUIDATION_CONCEPT, {
                    params: {
                        liquidationConceptCode: this.relatedEdit.code,
                    },
                })
                .then(({ data }) => {
                    if (data.code > 0) {
                        let index = this.listAddedConcepts.findIndex(e => e.code === data.info.code);
                        this.listAddedConcepts[index].value = data.info.value;
                        return;
                    }
                })
                .finally(() => {
                    this.$vs.loading.close();
                });
        },
        cleanFormConcept() {
            this.concept = null;
            this.runtimeType = null;
            this.showValue = false;
            this.showFunction = false;
            this.showRate = false;
            this.value = null;
            this.rate = null;
            this.functionType = null;
        },
        validateConceptRelated() {
            return !this.listAddedConcepts.find(e => e.concept.code === this.concept);
        }
    }
};
</script>
